import { ToastrService } from "ngx-toastr";
import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../services/authentincation.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
    loginData: any = {};

    showRegisterInfoModal = false;
    constructor(
        private toastr: ToastrService,
        private authenticationService: AuthenticationService,
        private router: Router,
    ) {}

    ngOnInit(): void {}

    login(loginData: any) {
        const t = this;

        this.authenticationService.login(loginData).subscribe(
            (data) => {
                t.toastr.success("Autentificare cu succes", "Autentificare");

                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));

                setTimeout(() => {
                    t.router.navigate(["/contul-meu"]);
                }, 1000);
            },
            () => {
                t.toastr.error("Credentiale invalide", "Autentificare");
            },
        );
    }
    openRegisterInfo(): void {
        this.showRegisterInfoModal = true;
    }

    closeRegisterInfo(): void {
        this.showRegisterInfoModal = false;
    }
}
